/**
 * Fixed 0–100 mapping for risk score charts. Visualization must use raw riskScore
 * values only — no min/max auto-scaling or normalization.
 */

export const RISK_SCORE_CHART_MIN = 0;
export const RISK_SCORE_CHART_MAX = 100;

/** @param {number} score raw risk score (0–100) */
export function clampRiskScoreForChart(score) {
  if (score == null || score === '') return null;
  const n = Number(score);
  if (!Number.isFinite(n)) return null;
  return Math.max(RISK_SCORE_CHART_MIN, Math.min(RISK_SCORE_CHART_MAX, n));
}

/**
 * Map a risk score to SVG y within the plot inner box (higher score = lower y).
 * @param {number} score
 * @param {{ innerH: number, padTop: number, yMin?: number, yMax?: number }} layout
 */
export function riskScoreToChartY(score, { innerH, padTop, yMin = RISK_SCORE_CHART_MIN, yMax = RISK_SCORE_CHART_MAX }) {
  const s = clampRiskScoreForChart(score);
  if (s == null || !Number.isFinite(innerH) || innerH <= 0) return null;
  const range = yMax - yMin || 1;
  const ratio = (s - yMin) / range;
  return padTop + innerH * (1 - ratio);
}

/**
 * @param {Array<{ score: number, y: number }>} pairs
 * @param {string} [context]
 */
export function warnIfRiskChartMappingDrift(pairs, context = 'risk chart') {
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'production') return;
  for (const { score, y, layout } of pairs) {
    const expected = riskScoreToChartY(score, layout);
    if (expected == null || y == null) continue;
    if (Math.abs(expected - y) > 0.75) {
      // eslint-disable-next-line no-console
      console.warn(
        `[${context}] plotted y does not match raw riskScore`,
        { score, expectedY: expected, actualY: y }
      );
    }
  }
}
